import React, { useContext } from "react"
import { IntlProvider, useIntl } from "react-intl"
import { Helmet } from "react-helmet"
import { defaultLocale, SupportedLocale } from "components/views/app/IntlMessages"
import { AdapterDayjs, LocalizationProvider } from "@carrotfertility/carotene-core"
import "dayjs/locale/es-us"
import "dayjs/locale/fr-ca"
import "dayjs/locale/de"
import "dayjs/locale/pt-br"
import "dayjs/locale/hi"
import { locale } from "dayjs"
import { setHeapLocale } from "utils/heap"

type PreferredLocaleProps = {
  // @ts-expect-error TS7051
  setPreferredLocale: (string) => void
  // @ts-expect-error TS7051
  setCompiledMessages: (Array) => void
}

export const PreferredLocaleContext = React.createContext<PreferredLocaleProps>({
  setPreferredLocale: null,
  setCompiledMessages: null
})
export const usePreferredLocaleContext = () => useContext(PreferredLocaleContext)

// @ts-expect-error TS7006
export function IntlProviderWrapper(props) {
  let intlStorage
  try {
    intlStorage = JSON.parse(localStorage.getItem("intl")) ?? {}
  } catch {
    intlStorage = {}
  }
  const [preferredLocale, setPreferredLocale] = React.useState(
    (intlStorage?.lastUsedLocale as SupportedLocale) ?? defaultLocale
  )
  const [compiledMessages, setCompiledMessages] = React.useState()

  React.useEffect(() => {
    localStorage.setItem("intl", JSON.stringify({ lastUsedLocale: preferredLocale }))
    try {
      window.OneTrust?.changeLanguage(preferredLocale)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }, [preferredLocale])

  React.useEffect(() => {
    setHeapLocale(preferredLocale)
  }, [preferredLocale])

  return (
    <PreferredLocaleContext.Provider value={{ setPreferredLocale, setCompiledMessages }}>
      <IntlProvider locale={preferredLocale} defaultLocale={defaultLocale} messages={compiledMessages}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale(preferredLocale)}>
          <HtmlLang />
          {props.children}
        </LocalizationProvider>
      </IntlProvider>
    </PreferredLocaleContext.Provider>
  )
}

function HtmlLang() {
  const { locale } = useIntl()

  return (
    <Helmet>
      <html lang={locale} />
    </Helmet>
  )
}
